export type FundCode = {
    FundID: number,
    FundName: string
}

export const FundCodes = [
    { FundID: 9001, FundName: 'AAMI' },
    { FundID: 9002, FundName: 'AHM' },
    { FundID: 9003, FundName: 'Apia' },
    { FundID: 9004, FundName: 'Australian Unity' },
    { FundID: 9005, FundName: 'Budget Direct' },
    { FundID: 9006, FundName: 'Bupa' },
    { FundID: 9007, FundName: 'CBHS Corporate' },
    { FundID: 9008, FundName: 'CDH Benefit' },
    { FundID: 9009, FundName: 'Defence Health' },
    { FundID: 9010, FundName: 'Frank Health Insurance' },
    { FundID: 9011, FundName: 'Great Southern Bank' },
    { FundID: 11, FundName: 'GMF Health Insurance' },
    { FundID: 31, FundName: 'GMHBA' },
    { FundID: 26, FundName: 'HBF' },
    { FundID: 7, FundName: 'HCF  ' },
    { FundID: 9012, FundName: 'Health Care Insurance' },
    { FundID: 9013, FundName: 'health.com.au' },
    { FundID: 9014, FundName: 'Health Partners' },
    { FundID: 9015, FundName: 'HIF' },
    { FundID: 9016, FundName: 'Latrobe Health Services' },
    { FundID: 3, FundName: 'Medibank' },
    { FundID: 9017, FundName: 'Mildura Health Fund' },
    { FundID: 9018, FundName: 'myOwn' },
    { FundID: 9019, FundName: 'Navy Health' },
    { FundID: 9020, FundName: 'NIB' },
    { FundID: 9021, FundName: 'Peoplecare' },
    { FundID: 9022, FundName: 'Phoenix Health Fund' },
    { FundID: 9023, FundName: 'Qantas' },
    { FundID: 9024, FundName: 'Queensland Country Health Fund' },
    { FundID: 9025, FundName: 'St.Luke’s Health' },
    { FundID: 9026, FundName: 'Teachers Health' },
    { FundID: 9, FundName: 'Westfund' },
    { FundID: 9999, FundName: 'Other' },
];